<div *ngIf="!formElement.hidden" [ngClass]="rowClass">
	<!-- <div class="row"> -->
	<label [for]="formElement.name" [ngClass]="labelClass || 'col-2 col-form-label right-text'">
		{{label || formElement.label}}
		<span class="mandatoryColor" *ngIf="(label || formElement.label) && (required ||formElement.required || formElement.showAstrisk)">*</span>
		<!-- <span class="mandatoryColor" *ngIf="(label || formElement.label) && (required ||formElement.required) && !formElement.silentRequired">*</span> -->
	</label>
	<div [ngClass]="inputClass || 'col-10'" *ngIf="type=='text'">
		<input [disabled]="isDisabled()" (keydown)="onKeydown($event)" [attr.maxlength]="formElement.maxFieldLength" (blur)="onBlur()"
		 [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.default" [id]="formElement.id || formElement.name || name" [type]="type" [placeholder]="formElement.readOnly ? '' : (placeholder || formElement.placeholder)"
		 [name]="name ||formElement.name" [(ngModel)]="value" (ngModelChange)="onChange()" [readonly]="isJssSchemeName">
		<span *ngIf="formElement.metainfo" class="m-form__help">
			{{formElement.metainfo.toString()}}
		</span>
		<span *ngIf="formElement.metaLink" (click)="formElement.metaLink?.onClick()" class="m--font-info link-text">
			{{formElement.metaLink?.text}}
		</span>
	</div>
	<div [ngClass]="inputClass || 'col-10'" *ngIf="type=='date'">
		<!-- <input autocomplete="off" [disabled]="isDisabled()" (keydown)="discardKey($event)" (blur)="value= dp.value; onChange(); onBlur()" [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.default" -->
		<input readonly autocomplete="off" [disabled]="isDisabled()" (blur)="dateValue= dp.value; onChange(); onBlur()" [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.default"
		 [id]="formElement.id" type="text" [placeholder]="formElement.readOnly ? '' : (placeholder || formElement.placeholder)"
		 [name]="name ||formElement.name" [(ngModel)]="dateValue" #dp>
		 <div class="input-group-append" (click)="focus(formElement.id)">
					<span class="input-group-text">
						<i class="la la-calendar-check-o"></i>
					</span>
				</div>
		<span *ngIf="formElement.metainfo" class="m-form__help">
			{{formElement.metainfo.toString()}}
		</span>
		<span *ngIf="formElement.metaLink" (click)="formElement.metaLink?.onClick()" class="m--font-info link-text">
			{{formElement.metaLink?.text}}
		</span>
	</div>
	<div [ngClass]="inputClass || 'col-10'" *ngIf="type == 'textarea'">
		<textarea [rows]=[formElement.styleRow] [disabled]="isDisabled()" [attr.maxlength]="formElement.maxFieldLength" (blur)="onChange(); onBlur()" [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.default"
		 [id]="formElement.id || formElement.name || name" [placeholder]="formElement.readOnly ? '' : (placeholder || formElement.placeholder)" [name]="name ||formElement.name"
		 [(ngModel)]="value" (ngModelChange)="onChange()"></textarea>
	</div>
	<div [ngClass]="inputClass || 'col-10'" *ngIf="type=='number'">
		<input [disabled]="isDisabled()" step=any (keydown)="onKeydown($event)" [attr.maxlength]="formElement.maxFieldLength"
		 (blur)="onBlur()" [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.default" [id]="formElement.id || formElement.name || name" [type]="type" [placeholder]="formElement.readOnly ? '' : (placeholder || formElement.placeholder)"
		 [name]="name ||formElement.name" [(ngModel)]="value" (ngModelChange)="onChange()">
		<span *ngIf="formElement.metainfo" class="m-form__help">
			{{formElement.metainfo.toString()}}
		</span>
		<span *ngIf="formElement.metaLink" (click)="formElement.metaLink?.onClick()" class="m--font-info link-text">
			{{formElement.metaLink?.text}}
		</span>
	</div>
	<ng-container *ngIf="!formElement.silentRequired">
		<label *ngIf="formElement.row" [for]="formElement.name" [ngClass]="labelClass">
		</label>
		<div [ngClass]="inputClass || 'col-10'">
			<ng-content></ng-content>
		</div>
	</ng-container>
	<ng-container *ngIf="formElement.silentRequired">
		<label *ngIf="formElement.row" [for]="formElement.name" [ngClass]="labelClass">
		</label>
		<div class="min-height-20">

		</div>
	</ng-container>

</div>
